import axios from "axios";
import ResponseAlerts from "../functions/ResponseAlerts";

class ImagesService {
	static async getImage(imgIdName) {
		return axios
			.get(`files?imageUrl=${imgIdName}`, {
				responseType: "text",
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				console.log(error);
				return error.response;
			});
	}

	static async getRawImage(url) {
		return axios
			.get(url, {
				responseType: "arraybuffer",
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				console.log(error);
				return error.response;
			});
	}

	static async storeImage(formData) {
		const file = formData.get("file");
		if (file && file.size > 200 * 1024) {
			const errorResponse = {
				status: 400,
				data: { message: "O arquivo deve ter no máximo 200kb." },
			};
			ResponseAlerts({ response: errorResponse });
			return errorResponse;
		}

		return axios
			.post("files/", formData)
			.then((response) => {
				ResponseAlerts({
					response: response,
					successMessage: "Imagem salva com sucesso",
				});
				return response;
			})
			.catch((error) => {
				console.log(error);
				ResponseAlerts({
					response: error.response,
					errorMessage: error.response.data.message || "Erro ao salvar imagem",
				});
				return error.response;
			});
	}

	static async storeInvitationImage(formData) {
		const file = formData.get("file");
		if (file && file.size > 200 * 1024) {
			const errorResponse = {
				status: 400,
				data: { message: "O arquivo deve ter no máximo 200kb." },
			};
			ResponseAlerts({ response: errorResponse });
			return errorResponse;
		}

		return axios
			.post("files/invitation", formData)
			.then((response) => {
				ResponseAlerts({
					response: response,
					successMessage: "Imagem salva com sucesso",
				});
				return response;
			})
			.catch((error) => {
				console.log(error);
				ResponseAlerts({
					response: error.response,
					errorMessage: error.response.data.message || "Erro ao salvar imagem",
				});
				return error.response;
			});
	}
}

export default ImagesService;
